import { ResponsiveBar } from "@nivo/bar";
import { Empty } from "antd";
import moment from "moment";
import { useGetDashboardBar2ChartCountQuery } from "../../services/api";
import { Loader } from "../loader";

interface ICreateDashboard {
  datas?: any;
}
export const BarChart2: React.FC<ICreateDashboard> = ({ datas }) => {
  const data = [
    {
      count: 0,
      month: "",
    },
  ];
  const userId = localStorage.getItem("user_id");
  const currentYear = moment().year();

  const dashboardBarParams2 = {
    id: userId,
    date_id: currentYear,
  };
  const { data: barCountData2, isLoading: barCount2Loading } =
    useGetDashboardBar2ChartCountQuery(dashboardBarParams2);
  const itemList = barCountData2?.data;

  return (
    <>
      {barCount2Loading ? (
        <div className="flex w-full justify-center items-center h-full">
          <Loader />
        </div>
      ) : itemList?.length > 0 ? (
        <ResponsiveBar
          data={itemList && itemList ? itemList : data}
          keys={["count"]}
          indexBy="month"
          margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
          padding={0.3}
          valueScale={{ type: "linear" }}
          indexScale={{ type: "band", round: true }}
          colors={"#F3A127"}
          defs={[
            {
              id: "dots",
              type: "patternDots",
              background: "inherit",
              color: "#38bcb2",
              size: 4,
              padding: 1,
              stagger: true,
            },
            {
              id: "lines",
              type: "patternLines",
              background: "inherit",
              color: "#eed312",
              rotation: -45,
              lineWidth: 6,
              spacing: 10,
            },
          ]}
          fill={[
            {
              match: {
                id: "fries",
              },
              id: "dots",
            },
            {
              match: {
                id: "sandwich",
              },
              id: "lines",
            },
          ]}
          borderColor={{
            from: "color",
            modifiers: [["darker", 1.6]],
          }}
          enableGridY={false}
          axisTop={null}
          axisRight={null}
          axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: "Month",
            legendPosition: "middle",
            legendOffset: 32,
          }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: "Count",
            legendPosition: "middle",
            legendOffset: -40,
          }}
          labelSkipWidth={12}
          labelSkipHeight={12}
          labelTextColor={{
            from: "color",
            modifiers: [["darker", 1.6]],
          }}
          legends={[
            {
              dataFrom: "keys",
              anchor: "bottom-right",
              direction: "column",
              justify: false,
              translateX: 120,
              translateY: 0,
              itemsSpacing: 2,
              itemWidth: 100,
              itemHeight: 20,
              itemDirection: "left-to-right",
              itemOpacity: 0.85,
              symbolSize: 20,
              effects: [
                {
                  on: "hover",
                  style: {
                    itemOpacity: 1,
                  },
                },
              ],
            },
          ]}
          role="application"
          ariaLabel="Nivo bar chart demo"
          barAriaLabel={(e) =>
            e.id + ": " + e.formattedValue + " in country: " + e.indexValue
          }
        />
      ) : (
        <Empty className="w-full h-full flex justify-center items-center flex-col" />
      )}
    </>
  );
};
